module.exports = __webpack_public_path__ + "static/undraw_new_message_2gfk-00859c34ae57234cc493f420e2c3f7d9.svg";